// extracted by mini-css-extract-plugin
module.exports = {"serviceAccordionWrapper":"ServiceAccordion_serviceAccordionWrapper__X9Xs8","divider":"ServiceAccordion_divider__1GNpW"};